<template>
  <Breadcrumbs :breadcrumbs="breadcrumbs" />

  <DynamicContent
    id="city-content-introduction"
    class="container dynamic-content"
    :html="content?.introductionBlock"
  />

  <!-- This city's folders -->
  <BrochuresGrid
    :input="{ citySlug: citySlug }"
    :pagination="{ limit: 20, offset: 0 }"
    :show-load-more="true"
    :infinite-loading="false"
    :title="isContentBlockEmpty(content?.introductionBlock) ? $t('city.city-brochures', [cityName]) : undefined"
    :impression-source="BrochureImpressionSource.City"
    class="mb-2"
    :tag="'h1'"
    :event-source="citySlug"
  />

  <DynamicContent
    id="city-content-similar"
    class="container dynamic-content"
    :html="content?.similarBlock"
  />

  <!-- Offers -->
  <OffersGrid
    :pagination="{ limit: 21, offset: 0 }"
    :input="{ citySlug: citySlug }"
    :title="isContentBlockEmpty(content?.similarBlock) ? $t('city.city-offers', [cityName]) : undefined"
    :infinite-loading="true"
    :tag="'h2'"
  />

  <DynamicContent
    id="city-content-timed"
    class="container dynamic-content"
    :html="content?.timedBlock"
  />
  <DynamicContent
    id="city-content-offers"
    class="container dynamic-content"
    :html="content?.offersBlock"
  />

</template>

<script setup lang="ts">
// This is the /city/offers route, where we show the offers for a specific city
import {
  BrochureImpressionSource,
  useCityQuery,
  useWebsitePageQuery,
} from "~/graphql/generated";

// It is a bit unfortunate that it shares a slug with the catch-all route, but that's just the nuxt filesystem routing
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/steden/[slug]",
    fr: "/villes/[slug]",
    nl: "/steden/[slug]",
  },
});

const citySlug = useRoute().params.slug as string;

// Fetch the city by slug
const { data, error } = await useCityQuery({
  variables: {
    cityInput: {
      slug: citySlug,
    },
  },
});
if (error?.value || !data.value?.city) {
  throw createError({ statusCode: 404, fatal: true });
}

const cityName = computed(() => {
  return data.value?.city?.name ?? "";
});

// Set the breadcrumbs
const breadcrumbs = [
  {
    to: "cities",
  },
  {
    to: "cities-slug",
    text: cityName.value,
  },
];

// Set the page title and meta
const { t } = useI18n();
useHead({
  title: t("city.title", [cityName.value]),
  meta: [
    {
      name: "description",
      content: t("city.meta-description", [cityName.value]),
    },
  ],
});

// Set the (optional) page content blocks
const path = useRoute().path;

const { websitePagePath } = useWebsitePagePath(path);

const page = await useWebsitePageQuery({
  variables: websitePagePath,
});

const content = useDynamicContent(page.data);
</script>
